import { ApiResponse } from './types';
import { apiClient } from './core/apiClient';
import { IUser } from '../types/interfaces/IUser';

export async function getUsers(): Promise<ApiResponse<IUser[]>> {
  return apiClient.get<IUser[]>('/users');
}

export async function getUserById(id: string): Promise<ApiResponse<IUser>> {
  return apiClient.get<IUser>(`/users/${id}`);
}

export async function createUser(
  data: Omit<IUser, 'id' | 'createdAt' | 'updatedAt'>
): Promise<ApiResponse<IUser>> {
  return apiClient.post<IUser>('/users', data);
}

export async function updateUser(
  id: string,
  data: Partial<IUser>
): Promise<ApiResponse<IUser>> {
  return apiClient.put<IUser>(`/users/${id}`, data);
}

export async function deleteUser(id: string): Promise<ApiResponse<boolean>> {
  return apiClient.delete<boolean>(`/users/${id}`);
}

export async function toggleUserStatus(id: string): Promise<ApiResponse<IUser>> {
  return apiClient.patch<IUser>(`/users/${id}/toggle-status`);
}
